import {GET_HOST_PROFILE_DATA,GET_HOST_PROFILE_DATA_SUCCESS, UPLOAD_CONTEST_DATA, UPLOAD_HOST_CONTEST_DATA, RESET_HOST_PROFILE_DATA, GET_HOST_PROFILE_MEDIA_SUCCESS, GET_HOST_PROFILE_MEDIA} from '../constants/actionTypes';

export const getHostProfileData = (payload)=>({
    type:GET_HOST_PROFILE_DATA,
    payload

})

export const getHostProfileDataSuccess = (payload)=>({
    type:GET_HOST_PROFILE_DATA_SUCCESS,
    payload
})

export const getHostProfileMedia = (payload)=>({
    type:GET_HOST_PROFILE_MEDIA,
    payload

})

export const getHostProfileMediaSuccess = (payload)=>({
    type:GET_HOST_PROFILE_MEDIA_SUCCESS,
    payload
})

export const uploadVideoData = (payload)=>({
    type:UPLOAD_HOST_CONTEST_DATA,
    payload
})

export const resetHostProfileData = ()=>({
    type:RESET_HOST_PROFILE_DATA
})